(() => {
  const entry = document.querySelector('[data-halloween-entry]');

  if (!entry) return;

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (reducedMotion) {
    entry.remove();
    return;
  }

  
  const storageKey = 'halloween-pumpkin-seen-v2';

  try {
    if (sessionStorage.getItem(storageKey)) {
      entry.remove();
      return;
    }

    sessionStorage.setItem(storageKey, 'true');
  } catch (error) {
    
  }

  const removeEntry = () => {
    if (entry.isConnected) {
      entry.remove();
    }
  };

  entry.classList.add('is-active');

  entry.addEventListener('animationend', (event) => {
    if (event.animationName === 'halloween-pumpkin-veil') {
      removeEntry();
    }
  });

  window.setTimeout(removeEntry, window.matchMedia('(max-width: 600px)').matches ? 2200 : 3700);
})();